import AcademicDepartmentTranscript from "./AcademicDepartmentTranscript";



export default AcademicDepartmentTranscript;